import React from 'react';

// Swaps the browser tab icon while a page is on screen and puts the site
// default back when it leaves. Mount it from a page that has its own product
// icon.

// what public/index.html ships with
const DEFAULT_ICON = `${process.env.PUBLIC_URL}/favicon.png`;
const DEFAULT_APPLE = `${process.env.PUBLIC_URL}/apple-touch-icon.jpg`;
const DEFAULT_TYPE = 'image/png';

const linkFor = rel => {
    let link = document.head.querySelector(`link[rel="${rel}"]`);

    if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        document.head.appendChild(link);
    }

    return link;
}

const apply = (icon, apple, type) => {
    const iconLink = linkFor('icon');

    iconLink.href = icon;

    if (type) {
        iconLink.type = type;
    } else {
        iconLink.removeAttribute('type');
    }

    linkFor('apple-touch-icon').href = apple;
}

// how many mounted pages are currently overriding the icon
let overrides = 0;

class Favicon extends React.Component {
  componentDidMount() {
    overrides += 1;
    apply(this.props.icon, this.props.apple || this.props.icon, this.props.type);
  }

  componentWillUnmount() {
    overrides -= 1;

    // deferred: moving between two pages that both override the icon unmounts
    // one before mounting the next, and restoring in between would flicker
    setTimeout(() => {
        if (overrides === 0) {
            apply(DEFAULT_ICON, DEFAULT_APPLE, DEFAULT_TYPE);
        }
    }, 0)
  }

  render() {
    return null
  }
}

export default Favicon;
